import React from 'react'
import { Container, Typography, Box, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import ModernFooter from '../Components/ModernFooter';
import SocialLink from '../Components/SocialLink';
import ContactComponent from '../Components/Contact';

import {
  fadeInUp,
} from '../styles/animations';

function Contact() {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box sx={{ backgroundColor: theme.palette.background.default, minHeight: '100vh' }}>
            {/* Hero Section */}
            <Box 
                sx={{
                    background: 'linear-gradient(135deg, #003d7a 0%, #1e5ba8 50%, #ff6b35 100%)',
                    color: 'white',
                    py: 8,
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <Container maxWidth="lg">
                    <motion.div
                        variants={fadeInUp}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Typography
                            variant="h3"
                            component="h1"
                            align="center"
                            gutterBottom
                            sx={{ fontWeight: 700, mb: 3 }}
                        >
                            {t("contenu.texte74")}
                        </Typography>
                        <Typography
                            variant="h6"
                            align="center"
                            sx={{ opacity: 0.9, maxWidth: 800, mx: 'auto' }}
                        >
                            Contactez-nous pour discuter de vos projets
                        </Typography>
                    </motion.div>
                </Container>
            </Box>

            {/* Contact Content */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                <motion.div
                    variants={fadeInUp}
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: true, amount: 0.3 }}
                >
                    <Box sx={{ mb: 6 }}>
                        <SocialLink />
                    </Box>
                    
                    <ContactComponent />
                </motion.div>
            </Container>
            
            <ModernFooter />
        </Box>
    )
}

export default Contact